module.exports = __webpack_public_path__ + "facebook.79d0954df3e73337850a78a3e9de143f.svg";